class Player {

    constructor(
        id,
        name,
        lastname,
        teamID,
        userID,
        createdAt,
        updatedAt,
        media,
        team,
    ){
        this.id = id || -1
        this.name = name || ""
        this.lastname = lastname || ""
        this.teamId = teamID || ""
        this.userID = userID || ""
        this.createdAt = createdAt || ""
        this.updatedAt = updatedAt || ""
        this.media = media || []
        this.team = team || []
    }

    static parse(responseData) {
        if(!responseData) return new Player()

        let d = responseData

        return new Player(
            d.id,
            d.name,
            d.lastname,
            d.team_id,
            d.user_id,
            d.created_at,
            d.updated_at,
            d.media ? d.media : null,
            d.team ? d.team : null
        )
    }
}

export default Player



// WEBPACK FOOTER //
// ./src/models/player.js